import mdastRawText from "lib/markdown/mdastRawText";
import parseMarkdown from "lib/markdown/parseMarkdown";

export default function stripMarkdown(message) {
  const mdast = parseMarkdown(message);
  const text = mdastRawText(mdast, 50);
  return text;
}
